'use strict';

/**
 *  Load modules
 */
import burgerMenu from './modules/burgerMenu';
import handorgel from './modules/handorgel.js';
import autoCompleteInit from './modules/autoCompleteInit.js';
import jumpLinks from './modules/jumpLinks.js';
import video from './modules/video.js';
import scrollTables from './modules/scrollTables.js';
import './mec-calendar-filters.js';

document.addEventListener("DOMContentLoaded", () => {
    autoCompleteInit();
    jumpLinks();
    scrollTables();

    const staffSearchInput = document.getElementById('staff-directory-search');
    if (staffSearchInput) {
        const list = document.querySelector('.staff-directory__autocomplete');
        const namesData = staffSearchInput.getAttribute('data-staff-names');
        let staffNames = [];
        try {
            staffNames = namesData ? JSON.parse(namesData) : [];
        } catch (e) {
            staffNames = [];
        }

        const updateDatalist = (query) => {
            if (!list) return;
            list.innerHTML = '';
            if (!query || query.length < 3) {
                list.hidden = true;
                return;
            }

            const q = query.toLowerCase();
            const matches = staffNames.filter((name) => name.toLowerCase().includes(q)).slice(0, 20);
            matches.forEach((name) => {
                const option = document.createElement('button');
                option.type = 'button';
                option.className = 'staff-directory__autocomplete-item';
                option.textContent = name;
                option.addEventListener('click', () => {
                    staffSearchInput.value = name;
                    list.hidden = true;
                });
                list.appendChild(option);
            });
            list.hidden = matches.length === 0;
        };

        staffSearchInput.addEventListener('input', (event) => {
            updateDatalist(event.target.value.trim());
        });

        staffSearchInput.addEventListener('blur', () => {
            setTimeout(() => {
                if (list) list.hidden = true;
            }, 150);
        });
    }

    const staffFiltersForm = document.querySelector('.staff-directory__filters');
    const staffDepartmentSelect = document.getElementById('staff-directory-department');
    if (staffFiltersForm && staffDepartmentSelect) {
        staffDepartmentSelect.addEventListener('change', () => {
            staffFiltersForm.submit();
        });
    }

    const staffClearBtn = document.getElementById('staff-directory-clear');
    if (staffClearBtn && staffFiltersForm) {
        staffClearBtn.addEventListener('click', () => {
            const searchInput = document.getElementById('staff-directory-search');
            const deptSelect  = document.getElementById('staff-directory-department');
            if (searchInput) searchInput.value = '';
            if (deptSelect)  deptSelect.value  = '';
            staffFiltersForm.submit();
        });
    }

    // Stick the filter bar to the top on mobile.
    // Uses a scroll listener + rAF instead of IntersectionObserver to avoid the
    // feedback loop where toggling is-stuck changes the sentinel's position and
    // immediately re-fires the observer, causing a flicker.
    if (staffFiltersForm && window.matchMedia('(max-width: 767px)').matches) {
        const sentinel = document.createElement('div');
        sentinel.setAttribute('aria-hidden', 'true');
        sentinel.style.height = '0';
        staffFiltersForm.parentNode.insertBefore(sentinel, staffFiltersForm);

        let ticking = false;

        const updateSticky = () => {
            const shouldBeStuck = sentinel.getBoundingClientRect().top <= 0;
            const isStuck = staffFiltersForm.classList.contains('is-stuck');

            if (shouldBeStuck === isStuck) {
                ticking = false;
                return;
            }

            if (shouldBeStuck) {
                // Measure height while form is still in normal flow, then go fixed
                sentinel.style.height = staffFiltersForm.offsetHeight + 'px';
                staffFiltersForm.classList.add('is-stuck');
            } else {
                // Return form to flow first, then release the sentinel space
                staffFiltersForm.classList.remove('is-stuck');
                sentinel.style.height = '0';
            }
            ticking = false;
        };

        window.addEventListener('scroll', () => {
            if (!ticking) {
                requestAnimationFrame(updateSticky);
                ticking = true;
            }
        }, { passive: true });

        // Run once on load in case the page is already scrolled
        updateSticky();
    }

    // Staff directory: Load More
    const loadMoreBtn = document.getElementById('staff-load-more');
    const staffGrid   = document.getElementById('staff-directory-grid');
    if (loadMoreBtn && staffGrid) {
        loadMoreBtn.addEventListener('click', async () => {
            const page       = parseInt(loadMoreBtn.dataset.page, 10) + 1;
            const maxPages   = parseInt(loadMoreBtn.dataset.maxPages, 10);
            const search     = loadMoreBtn.dataset.search || '';
            const department = loadMoreBtn.dataset.department || '';

            loadMoreBtn.disabled = true;
            loadMoreBtn.textContent = 'Loading\u2026';

            const formData = new FormData();
            formData.append('action', 'load_more_staff');
            formData.append('nonce',  myajax.nonce);
            formData.append('page',       page);
            formData.append('search',     search);
            formData.append('department', department);

            try {
                const response = await fetch(myajax.url, { method: 'POST', body: formData });
                const data     = await response.json();

                if (data.success && data.data.html) {
                    staffGrid.insertAdjacentHTML('beforeend', data.data.html);
                    loadMoreBtn.dataset.page = page;

                    if (!data.data.has_more) {
                        const wrap = loadMoreBtn.closest('.staff-directory__load-more-wrap');
                        const backToTop = document.createElement('a');
                        backToTop.href = '#';
                        backToTop.className = 'staff-directory__back-to-top';
                        backToTop.textContent = 'Back to Top';
                        backToTop.addEventListener('click', (e) => {
                            e.preventDefault();
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                        });
                        wrap.replaceChildren(backToTop);
                    } else {
                        loadMoreBtn.disabled    = false;
                        loadMoreBtn.textContent = 'Load More';
                    }
                }
            } catch (e) {
                loadMoreBtn.disabled    = false;
                loadMoreBtn.textContent = 'Load More';
            }
        });
    }

    // Define function to add live region for form confirmation to all Gravity Forms forms
    const ensureGformStatusLiveRegion = (form) => {
        const id = form.getAttribute('id')?.replace('gform_', '');
        if (!id) return;
        if (document.getElementById(`gform_status_${id}`)) return;

        const live = document.createElement('div');
        live.id = `gform_status_${id}`;
        live.className = 'sr-only';
        live.setAttribute('role', 'status');
        live.setAttribute('aria-live', 'polite');
        live.setAttribute('aria-atomic', 'true');
        // Place outside the wrapper so AJAX replacements don't remove it.
        const wrapper = document.getElementById(`gform_wrapper_${id}`);
        if (wrapper && wrapper.parentNode) {
            wrapper.parentNode.insertBefore(live, wrapper);
        } else {
            form.parentNode.insertBefore(live, form);
        }
    };

    // Add live region for form confirmation to all Gravity Forms forms using the function defined above
    document.querySelectorAll('form[id^="gform_"]').forEach(ensureGformStatusLiveRegion);

    document.addEventListener('gform_post_render', (event) => {
        const formId = event?.detail?.[1];
        if (!formId) return;
        const form = document.getElementById(`gform_${formId}`);
        if (form) {
            ensureGformStatusLiveRegion(form);
        }
    });

    const searchModals = document.querySelectorAll('.modal-search');

    searchModals.forEach(modal => {
        const input = modal.querySelector('input[type="search"]');
        const wrapper = input?.parentElement;

        if (input && wrapper) {
            const updateFilledClass = () => {
                if (input.value.trim() !== "") {
                    wrapper.classList.add('filled');
                } else {
                    wrapper.classList.remove('filled');
                }
            };

            input.addEventListener('input', updateFilledClass);

            updateFilledClass();
        }
    });

    const fillText = document.getElementById('fillText');
    const container = fillText?.parentElement;

    let scrollStarted = false;
    let ticking = false;

    function updateFillTextAnimation () {
        if (!scrollStarted || !fillText || !container) return;

        const rect = container.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        const triggerOffset = 0;
        const distanceFromBottom = windowHeight - rect.top - triggerOffset;

        let visible = distanceFromBottom / rect.height;
        visible = Math.min(Math.max(visible, 0), 1);

        const clipBottom = 110 - visible * 100;
        fillText.style.clipPath = `inset(0 0 ${clipBottom}% 0)`;
    }

    window.addEventListener('scroll', () => {
        scrollStarted = true;
        if (!ticking) {
            window.requestAnimationFrame(() => {
                updateFillTextAnimation();
                ticking = false;
            });
            ticking = true;
        }
    });

    window.addEventListener('load', () => {
        if (fillText) {
            fillText.style.clipPath = 'inset(0 0 110% 0)';
        }
    });

    const hash = window.location.hash;
    if (hash) {
        const targetEl = document.querySelector(hash);
        if (targetEl) {
            setTimeout(() => {
                targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 100);
        }
    }

    // Force external links to open in new window
    const currentDomain = window.location.hostname;
    const allLinks = document.querySelectorAll('a[href]');
    const mediaExtensions = new Set([
        'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'csv', 'zip',
        'mp4', 'mov', 'webm', 'mp3', 'wav'
    ]);

    allLinks.forEach(link => {
        const href = link.getAttribute('href');
        
        // Skip if href missing or is internal anchor
        if (!href || href.startsWith('#')) {
            return;
        }

        try {
            const linkUrl = new URL(href, window.location.origin);
            const isSameDomain = linkUrl.hostname === currentDomain;
            const isHttp = linkUrl.protocol === 'http:' || linkUrl.protocol === 'https:';
            const extension = linkUrl.pathname.split('.').pop().toLowerCase();
            const isMedia = mediaExtensions.has(extension);

            if (isHttp && !isSameDomain) {
                link.setAttribute('target', '_blank');
                link.setAttribute('rel', 'noopener noreferrer');
                return;
            }

            // Internal links should not open new tabs unless they are media files.
            if (isHttp && isSameDomain && !isMedia && link.getAttribute('target') === '_blank') {
                link.removeAttribute('target');
                link.removeAttribute('rel');
            }
        } catch (e) {
            // If URL parsing fails, log for debugging
            console.log('Could not parse URL:', href);
        }
    });
});

// ---------------------------------------------------------------------------
// Directory listing preview — Form 266
// ---------------------------------------------------------------------------
(function () {
    const FORM_ID = 266;

    const EMAIL_SVG = '<svg class="staff-directory__item__icon" width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M18.7 0H3.3C2.42479 0 1.58542 0.335825 0.966548 0.933597C0.347678 1.53137 0 2.34212 0 3.1875V13.8125C0 14.6579 0.347678 15.4686 0.966548 16.0664C1.58542 16.6642 2.42479 17 3.3 17H18.7C19.5752 17 20.4146 16.6642 21.0335 16.0664C21.6523 15.4686 22 14.6579 22 13.8125V3.1875C22 2.34212 21.6523 1.53137 21.0335 0.933597C20.4146 0.335825 19.5752 0 18.7 0ZM18.249 2.125L11.781 8.3725C11.6787 8.47209 11.5571 8.55113 11.423 8.60507C11.289 8.65901 11.1452 8.68679 11 8.68679C10.8548 8.68679 10.711 8.65901 10.577 8.60507C10.4429 8.55113 10.3213 8.47209 10.219 8.3725L3.751 2.125H18.249ZM19.8 13.8125C19.8 14.0943 19.6841 14.3645 19.4778 14.5638C19.2715 14.7631 18.9917 14.875 18.7 14.875H3.3C3.00826 14.875 2.72847 14.7631 2.52218 14.5638C2.31589 14.3645 2.2 14.0943 2.2 13.8125V3.62312L8.668 9.87062C9.28675 10.4675 10.1255 10.8028 11 10.8028C11.8745 10.8028 12.7132 10.4675 13.332 9.87062L19.8 3.62312V13.8125Z" fill="#6F2978"/></svg>';
    const PHONE_SVG = '<svg class="staff-directory__item__icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M17.4582 10.9603C17.2382 10.9603 17.0082 10.8903 16.7882 10.8403C16.3427 10.7421 15.9048 10.6118 15.4782 10.4503C15.0143 10.2815 14.5043 10.2903 14.0465 10.4749C13.5886 10.6595 13.2153 11.007 12.9982 11.4503L12.7782 11.9003C11.8042 11.3585 10.9092 10.6855 10.1182 9.90032C9.33294 9.10933 8.65999 8.21431 8.11817 7.24032L8.53817 6.96032C8.98153 6.74323 9.32895 6.36985 9.51356 5.91201C9.69817 5.45417 9.70694 4.94423 9.53817 4.48032C9.37939 4.05274 9.2491 3.61512 9.14817 3.17032C9.09817 2.95032 9.05817 2.72032 9.02817 2.49032C8.90673 1.78594 8.53779 1.14806 7.98779 0.691557C7.43779 0.235054 6.74286 -0.0100738 6.02817 0.000317303H3.02817C2.5972 -0.00372924 2.17042 0.0851307 1.77688 0.260848C1.38334 0.436565 1.03228 0.695013 0.747598 1.0186C0.462918 1.34219 0.251302 1.72331 0.127155 2.13603C0.00300869 2.54875 -0.0307535 2.98338 0.0281672 3.41032C0.560905 7.5997 2.4742 11.4922 5.46582 14.473C8.45744 17.4537 12.3569 19.3528 16.5482 19.8703H16.9282C17.6656 19.8714 18.3776 19.6008 18.9282 19.1103C19.2445 18.8274 19.4973 18.4805 19.6696 18.0926C19.842 17.7048 19.9301 17.2848 19.9282 16.8603V13.8603C19.9159 13.1657 19.663 12.4969 19.2125 11.968C18.762 11.4391 18.142 11.0829 17.4582 10.9603ZM17.9582 16.9603C17.958 17.1023 17.9276 17.2426 17.8689 17.3719C17.8103 17.5013 17.7248 17.6166 17.6182 17.7103C17.5064 17.8068 17.3758 17.8789 17.2346 17.9219C17.0934 17.965 16.9447 17.978 16.7982 17.9603C13.0531 17.4801 9.5744 15.7668 6.91088 13.0906C4.24736 10.4144 2.55058 6.92765 2.08817 3.18032C2.07225 3.03384 2.0862 2.88565 2.12917 2.74471C2.17214 2.60377 2.24324 2.473 2.33817 2.36032C2.43188 2.25365 2.54723 2.16816 2.67655 2.10953C2.80586 2.05091 2.94618 2.0205 3.08817 2.02032H6.08817C6.32071 2.01514 6.54779 2.0912 6.73031 2.23539C6.91283 2.37958 7.03938 2.58289 7.08817 2.81032C7.12817 3.08365 7.17817 3.35365 7.23817 3.62032C7.35369 4.14746 7.50743 4.6655 7.69817 5.17032L6.29817 5.82032C6.17846 5.87524 6.07079 5.95326 5.98132 6.04991C5.89186 6.14656 5.82237 6.25993 5.77684 6.38351C5.73131 6.50709 5.71064 6.63845 5.71601 6.77004C5.72139 6.90163 5.75271 7.03086 5.80817 7.15032C7.24737 10.2331 9.72541 12.7111 12.8082 14.1503C13.0516 14.2503 13.3247 14.2503 13.5682 14.1503C13.6929 14.1057 13.8075 14.0368 13.9053 13.9475C14.0032 13.8582 14.0823 13.7504 14.1382 13.6303L14.7582 12.2303C15.2751 12.4152 15.8028 12.5688 16.3382 12.6903C16.6048 12.7503 16.8748 12.8003 17.1482 12.8403C17.3756 12.8891 17.5789 13.0157 17.7231 13.1982C17.8673 13.3807 17.9433 13.6078 17.9382 13.8403L17.9582 16.9603Z" fill="#6F2978"/></svg>';
    const PLACEHOLDER_IMG = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'><rect width='100' height='100' fill='%23EFEFEF'/><text x='50' y='56' font-size='12' text-anchor='middle' fill='%23999999' font-family='Arial, sans-serif'>Photo</text></svg>";
    // PHOTO_YES_IMG: consent given but no photo uploaded yet (staff_placeholder_consent)
    // PHOTO_NO_IMG:  no consent / default state               (staff_placeholder)
    const PHOTO_YES_IMG = (window.staffPlaceholders && window.staffPlaceholders.consent) || '';
    const PHOTO_NO_IMG  = (window.staffPlaceholders && window.staffPlaceholders.default) || '';

    function formatPhone(raw) {
        const digits = raw.replace(/\D/g, '');
        if (digits.length === 11 && digits[0] === '1') return '(' + digits.slice(1,4) + ') ' + digits.slice(4,7) + '-' + digits.slice(7);
        if (digits.length === 10) return '(' + digits.slice(0,3) + ') ' + digits.slice(3,6) + '-' + digits.slice(6);
        return raw;
    }

    function buildPreviewHTML() {
        return `<div class="gf-directory-preview">
            <div class="gf-directory-preview__inner">
            <p class="gf-directory-preview__heading">Listing Preview</p>
            <ul class="staff-directory staff-directory--preview" style="list-style:none;margin:0;padding:0;">
                <li class="staff-directory__item">
                    <article>
                        <div class="staff-directory__item__header">
                            <div class="staff-directory__item__media">
                                <img src="${PLACEHOLDER_IMG}" alt="Photo placeholder" width="100" height="100">
                            </div>
                            <div class="staff-directory__item__name-wrap">
                                <h2 class="staff-directory__item__name js-preview-name">Your Name</h2>
                                <p class="staff-directory__item__title js-preview-position">Job Title</p>
                            </div>
                        </div>
                        <p class="staff-directory__item__departments js-preview-dept-wrap">
                            <span class="staff-directory__item__department-tag js-preview-dept">Department</span>
                        </p>
                        <p class="staff-directory__item__location js-preview-location" style="display:none;"><span class="staff-directory__item__building js-preview-building"></span><span class="js-preview-location-sep" style="display:none;">, </span><span class="staff-directory__item__address js-preview-address"></span></p>
                        <p class="staff-directory__item__email js-preview-email-wrap" style="display:none;">
                            <a href="#" class="js-preview-email-link">
                                ${EMAIL_SVG}
                                <span class="js-preview-email-text"></span>
                            </a>
                        </p>
                        <p class="staff-directory__item__phone js-preview-phone-wrap" style="display:none;">
                            <a href="#" class="js-preview-phone-link">
                                ${PHONE_SVG}
                                <span class="js-preview-phone-text"></span>
                            </a>
                        </p>
                    </article>
                    <div class="staff-directory__item__link js-preview-link-wrap" style="display:none;">
                        <a href="#" class="btn js-preview-link-anchor">Schedule Advising Appointment</a>
                    </div>
                </li>
            </ul>
            </div>
        </div>`;
    }

    function initDirectoryPreview(formId) {
        if (parseInt(formId) !== FORM_ID) return;

        const formWrapper = document.getElementById('gform_wrapper_' + FORM_ID);
        if (!formWrapper) return;

        // Wrap form and inject preview sibling only once
        let outerWrap = document.getElementById('gf-listing-preview-wrap');
        if (!outerWrap) {
            outerWrap = document.createElement('div');
            outerWrap.id = 'gf-listing-preview-wrap';
            outerWrap.className = 'gf-listing-preview-wrap';
            formWrapper.parentNode.insertBefore(outerWrap, formWrapper);
            outerWrap.appendChild(formWrapper);
            // GF sets display:none on the wrapper initially — clear it after moving
            formWrapper.style.removeProperty('display');
            outerWrap.insertAdjacentHTML('beforeend', buildPreviewHTML());
        }

        const preview = outerWrap.querySelector('.gf-directory-preview');

        // Syncs the combined location <p> visibility and separator based on building/address content
        function updateLocationWrap(p) {
            const building = p.querySelector('.js-preview-building').textContent.trim();
            const address  = p.querySelector('.js-preview-address').textContent.trim();
            const wrap     = p.querySelector('.js-preview-location');
            const sep      = p.querySelector('.js-preview-location-sep');
            wrap.style.display = (building || address) ? '' : 'none';
            sep.style.display  = (building && address) ? '' : 'none';
        }

        // Returns true when the form is in create-new-listing mode
        function isCreateMode() {
            const checked = document.querySelector('input[name="input_27"]:checked');
            return !checked || checked.value === 'create';
        }

        // Field map: selector → updater function
        // fieldMode: 'edit'  = only active when editing an existing listing (PA-populated fields)
        //            'create' = only active when creating a new listing (user-typed, no PA)
        //            'both'  = shared across both modes (radio choices, photo consent, etc.)
        const fields = [
            // ---- Edit-mode fields (Populate Anything fills these from the member select) ----
            {
                fieldMode: 'edit', sel: '#input_266_17',
                update(val) {
                    preview.querySelector('.js-preview-name').textContent = val.trim() || 'Your Name';
                }
            },
            {
                fieldMode: 'edit', sel: '#input_266_12',
                update(val) {
                    preview.querySelector('.js-preview-position').textContent = val.trim() || 'Job Title';
                }
            },
            {
                fieldMode: 'edit', sel: '#input_266_13',
                update(val, el) {
                    const label = el.options[el.selectedIndex] ? el.options[el.selectedIndex].text : '';
                    const deptWrap = preview.querySelector('.js-preview-dept-wrap');
                    preview.querySelector('.js-preview-dept').textContent = label;
                    deptWrap.style.display = label ? '' : 'none';
                }
            },
            {
                fieldMode: 'edit', sel: '#input_266_14',
                update(val) {
                    const wrap = preview.querySelector('.js-preview-email-wrap');
                    const link = preview.querySelector('.js-preview-email-link');
                    preview.querySelector('.js-preview-email-text').textContent = val.trim();
                    link.href = val.trim() ? 'mailto:' + val.trim() : '#';
                    wrap.style.display = val.trim() ? '' : 'none';
                }
            },
            {
                fieldMode: 'edit', sel: '#input_266_8',
                update(val) {
                    const wrap = preview.querySelector('.js-preview-phone-wrap');
                    const link = preview.querySelector('.js-preview-phone-link');
                    const formatted = formatPhone(val);
                    preview.querySelector('.js-preview-phone-text').textContent = formatted;
                    link.href = val.trim() ? 'tel:' + val.replace(/\D/g, '') : '#';
                    wrap.style.display = val.trim() ? '' : 'none';
                }
            },
            {
                fieldMode: 'edit', sel: '#input_266_19',
                update(val) {
                    preview.querySelector('.js-preview-building').textContent = val.trim();
                    updateLocationWrap(preview);
                }
            },
            {
                fieldMode: 'edit', sel: '#input_266_25',
                update(val) {
                    preview.querySelector('.js-preview-address').textContent = val.trim();
                    updateLocationWrap(preview);
                }
            },
            {
                fieldMode: 'edit', sel: '#input_266_24',
                update(val) {
                    preview.querySelector('.js-preview-link-anchor').textContent = val.trim();
                }
            },
            {
                fieldMode: 'edit', sel: '#input_266_22',
                update(val) {
                    preview.querySelector('.js-preview-link-anchor').href = val.trim() || '#';
                }
            },
            // ---- Create-mode fields (plain inputs, no PA wiring) ----
            {
                fieldMode: 'create', sel: '#input_266_28', // Name 2
                update(val) {
                    preview.querySelector('.js-preview-name').textContent = val.trim() || 'Your Name';
                }
            },
            {
                fieldMode: 'create', sel: '#input_266_29', // Title 2
                update(val) {
                    preview.querySelector('.js-preview-position').textContent = val.trim() || 'Job Title';
                }
            },
            {
                fieldMode: 'create', sel: '#input_266_30', // Department 2
                update(val, el) {
                    const label = el.options && el.options[el.selectedIndex] ? el.options[el.selectedIndex].text : val;
                    const deptWrap = preview.querySelector('.js-preview-dept-wrap');
                    preview.querySelector('.js-preview-dept').textContent = label;
                    deptWrap.style.display = label ? '' : 'none';
                }
            },
            {
                fieldMode: 'create', sel: '#input_266_31', // Email 2
                update(val) {
                    const wrap = preview.querySelector('.js-preview-email-wrap');
                    const link = preview.querySelector('.js-preview-email-link');
                    preview.querySelector('.js-preview-email-text').textContent = val.trim();
                    link.href = val.trim() ? 'mailto:' + val.trim() : '#';
                    wrap.style.display = val.trim() ? '' : 'none';
                }
            },
            {
                fieldMode: 'create', sel: '#input_266_32', // Phone 2
                update(val) {
                    const wrap = preview.querySelector('.js-preview-phone-wrap');
                    const link = preview.querySelector('.js-preview-phone-link');
                    const formatted = formatPhone(val);
                    preview.querySelector('.js-preview-phone-text').textContent = formatted;
                    link.href = val.trim() ? 'tel:' + val.replace(/\D/g, '') : '#';
                    wrap.style.display = val.trim() ? '' : 'none';
                }
            },
            {
                fieldMode: 'create', sel: '#input_266_34', // Building 2
                update(val) {
                    preview.querySelector('.js-preview-building').textContent = val.trim();
                    updateLocationWrap(preview);
                }
            },
            {
                fieldMode: 'create', sel: '#input_266_35', // Address 2
                update(val) {
                    preview.querySelector('.js-preview-address').textContent = val.trim();
                    updateLocationWrap(preview);
                }
            },
            {
                fieldMode: 'create', sel: '#input_266_37', // Link Text 2
                update(val) {
                    preview.querySelector('.js-preview-link-anchor').textContent = val.trim();
                }
            },
            {
                fieldMode: 'create', sel: '#input_266_38', // Link URL 2
                update(val) {
                    preview.querySelector('.js-preview-link-anchor').href = val.trim() || '#';
                }
            },
            {
                fieldMode: 'create', sel: 'input[name="input_36"]', // "Add optional link?" radio (create)
                update(val) {
                    const wrap = preview.querySelector('.js-preview-link-wrap');
                    wrap.style.display = (val.toLowerCase() === 'yes') ? '' : 'none';
                }
            },
            // ---- Shared fields — apply in both modes ----
            {
                fieldMode: 'both', sel: 'input[name="input_20"]', // Photo consent radio
                update(val, el) {
                    const img = preview.querySelector('.staff-directory__item__media img');
                    if (!img) return;
                    img.src = (el && el.id === 'choice_266_20_0') ? PHOTO_YES_IMG : PHOTO_NO_IMG;
                }
            },
            {
                fieldMode: 'edit', sel: 'input[name="input_23"]', // "Add optional link?" radio (edit)
                update(val) {
                    const wrap = preview.querySelector('.js-preview-link-wrap');
                    wrap.style.display = (val.toLowerCase() === 'yes') ? '' : 'none';
                }
            },
        ];

        // Resets the phone confirmation field and clears any match error
        function resetPhoneConfirm() {
            const confirmField = document.getElementById('input_266_21');
            if (!confirmField) return;
            confirmField.value = '';
            confirmField.setAttribute('aria-invalid', 'false');
            const container  = document.getElementById('field_266_21');
            const msg        = container ? container.querySelector('#validation_message_266_21') : null;
            const formatHint = container ? container.querySelector('.gfield_description.instruction') : null;
            if (msg) msg.remove();
            if (formatHint) formatHint.style.removeProperty('display');
        }

        // Re-reads every field's current value and pushes it to the preview.
        // Only processes fields matching the active mode (create/edit) plus shared fields.
        function refreshPreview() {
            const mode = isCreateMode() ? 'create' : 'edit';
            fields.forEach(({ sel, fieldMode, update }) => {
                if (fieldMode !== 'both' && fieldMode !== mode) return;
                const isRadioGroup = sel.startsWith('input[name=');
                if (isRadioGroup) {
                    const checked = document.querySelector(sel + ':checked');
                    if (checked) update(checked.value, checked);
                    return;
                }
                const el = document.querySelector(sel);
                if (el) update(el.value, el);
            });
        }

        fields.forEach(({ sel, fieldMode, update }) => {
            // Radio groups: bind to every input in the group, read checked value
            const isRadioGroup = sel.startsWith('input[name=');
            if (isRadioGroup) {
                const radios = document.querySelectorAll(sel);
                if (!radios.length) return;
                radios.forEach(radio => {
                    radio.addEventListener('change', () => {
                        const mode = isCreateMode() ? 'create' : 'edit';
                        if (fieldMode === 'both' || fieldMode === mode) update(radio.value, radio);
                    });
                });
                const checked = document.querySelector(sel + ':checked');
                if (checked) update(checked.value, checked);
                return;
            }

            const el = document.querySelector(sel);
            if (!el) return;
            const handler = () => {
                const mode = isCreateMode() ? 'create' : 'edit';
                if (fieldMode === 'both' || fieldMode === mode) update(el.value, el);
            };
            el.addEventListener('input', handler);
            el.addEventListener('change', handler);
            // keyup catches Inputmask-enhanced fields (e.g. phone) where the
            // native 'input' event may not fire reliably while typing
            el.addEventListener('keyup', handler);
            handler(); // populate from any pre-filled value
        });

        // Delegated change listener for <select> fields.
        // Direct listeners on select elements can become detached when:
        //   (a) Populate Anything replaces a field's markup via AJAX, or
        //   (b) TomSelect re-initializes after GF conditional logic shows a field.
        // outerWrap is never replaced, so delegation here is always reliable.
        outerWrap.addEventListener('change', function (e) {
            if (e.target.tagName !== 'SELECT') return;
            const targetId = '#' + e.target.id;
            const field = fields.find(f => f.sel === targetId);
            if (!field) return;
            const mode = isCreateMode() ? 'create' : 'edit';
            if (field.fieldMode !== 'both' && field.fieldMode !== mode) return;
            field.update(e.target.value, e.target);
        });

        // Phone confirmation — validate on blur, capturing values synchronously
        // to avoid race conditions with Populate Anything async field updates.
        const phoneField   = document.getElementById('input_266_8');
        const phoneConfirm = document.getElementById('input_266_21');
        if (phoneField && phoneConfirm) {
            phoneConfirm.setAttribute('autocomplete', 'off');

            function digitsOnly(val) {
                const d = (val || '').replace(/\D/g, '');
                return (d.length === 11 && d[0] === '1') ? d.slice(1) : d;
            }

            function validatePhoneMatch(primaryVal, confirmVal) {
                const container  = document.getElementById('field_266_21');
                const formatHint = container ? container.querySelector('.gfield_description.instruction') : null;
                let msg = container ? container.querySelector('#validation_message_266_21') : null;

                const primary = digitsOnly(primaryVal);
                const confirm = digitsOnly(confirmVal);

                if (confirm && primary !== confirm) {
                    phoneConfirm.setAttribute('aria-invalid', 'true');
                    if (!msg && container) {
                        msg = document.createElement('div');
                        msg.className = 'gfield_description validation_message';
                        msg.id = 'validation_message_266_21';
                        container.appendChild(msg);
                    }
                    if (msg) msg.textContent = 'Phone numbers do not match.';
                    if (formatHint) formatHint.style.display = 'none';
                } else {
                    phoneConfirm.setAttribute('aria-invalid', 'false');
                    if (msg) msg.remove();
                    if (formatHint) formatHint.style.removeProperty('display');
                }
            }

            // Capture both values at the instant of blur — before any async
            // Populate Anything update can overwrite them.
            phoneConfirm.addEventListener('blur', function () {
                validatePhoneMatch(phoneField.value, this.value);
            });
            phoneField.addEventListener('blur', function () {
                validatePhoneMatch(this.value, phoneConfirm.value);
            });
        }

        // When a new member is selected, wait until the name field has updated then refresh preview
        const memberSelect = document.getElementById('input_266_4');
        const nameField = document.getElementById('input_266_17');
        if (memberSelect && nameField) {
            memberSelect.addEventListener('change', function () {
                const prevName = nameField.value;
                let attempts = 0;
                const poll = setInterval(function () {
                    attempts++;
                    // Once the name field value has changed (or 3s max), stop polling
                    if (nameField.value !== prevName || attempts >= 30) {
                        clearInterval(poll);
                        // Give GF an extra 400ms to finish populating remaining fields
                        setTimeout(function () {
                            refreshPreview();
                            // Only reset confirmation if user hasn't already typed in it
                            const confirmEl = document.getElementById('input_266_21');
                            if (!confirmEl || !confirmEl.value.trim()) {
                                resetPhoneConfirm();
                            }
                        }, 400);
                    }
                }, 100);
            });
        }

        // ---------------------------------------------------------------------------
        // Create vs. Edit mode — radio field 27 + URL ?member_id parameter
        // ---------------------------------------------------------------------------
        const actionRadios = document.querySelectorAll('input[name="input_27"]');
        const memberIdParam = new URLSearchParams(window.location.search).get('member_id');

        // Programmatically select a radio and trigger GF's conditional logic
        function setActionMode(mode) {
            actionRadios.forEach(radio => { radio.checked = (radio.value === mode); });
            const selected = document.querySelector('input[name="input_27"][value="' + mode + '"]');
            if (selected) {
                selected.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }

        if (actionRadios.length) {
            // When GF returns validation errors the page reloads but GF preserves all
            // submitted field values — including radio field 27 (create/edit). It also
            // marks the form wrapper with gform_validation_error. In that case we skip
            // URL-param logic entirely and restore the UI from the already-correct radio
            // state that GF pre-filled for us.
            const hasValidationErrors = !!outerWrap.querySelector('.gform_validation_error');

            if (hasValidationErrors) {
                // GF has already checked the right radio. Dispatch a change event so GF's
                // own conditional logic re-evaluates field visibility to match that state.
                const restoredRadio = document.querySelector('input[name="input_27"]:checked');
                const restoredMode  = restoredRadio ? restoredRadio.value : 'create';
                setActionMode(restoredMode);
                // Populate the preview from the re-filled field values
                refreshPreview();
            } else if (memberIdParam) {
                // Normal load with a member ID in the URL — switch to edit mode so GF's
                // conditional logic reveals the listing dropdown. PA populates the dropdown
                // from the URL param; poll until the name field updates then sync the preview.
                const prevNameOnLoad = nameField ? nameField.value : '';
                setActionMode('edit');

                let loadAttempts = 0;
                const loadPoll = setInterval(function () {
                    loadAttempts++;
                    if ((nameField && nameField.value !== prevNameOnLoad) || loadAttempts >= 40) {
                        clearInterval(loadPoll);
                        setTimeout(refreshPreview, 400);
                    }
                }, 100);
            } else {
                // Normal load with no member ID — default to create mode
                setActionMode('create');
            }

            // Refresh the preview whenever the user toggles between create and edit mode
            actionRadios.forEach(radio => {
                radio.addEventListener('change', refreshPreview);
            });
        }

        // Shared matchMedia query used by both the scroll tracker and the scroll link
        const mq = window.matchMedia('(min-width: 1024px)');

        // Inject "back to preview" link above form footer, shown on mobile only
        const formBody = document.querySelector('#gform_' + FORM_ID + ' .gform_fields');
        if (formBody) {
            const previewInner = outerWrap.querySelector('.gf-directory-preview__inner');
            if (previewInner) previewInner.id = 'gf-listing-preview-anchor';

            const scrollLink = document.createElement('p');
            scrollLink.id = 'gf-preview-scroll-link';
            scrollLink.className = 'gf-preview-scroll-link';
            scrollLink.style.gridColumn = '1 / -1';
            scrollLink.innerHTML = '<a href="#gf-listing-preview-anchor">&#8593; View listing preview</a>';
            scrollLink.querySelector('a').addEventListener('click', function (e) {
                e.preventDefault();
                document.getElementById('gf-listing-preview-anchor').scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
            formBody.appendChild(scrollLink);
            scrollLink.style.display = mq.matches ? 'none' : '';
        }

        // Fake sticky via scroll tracking (position:sticky is blocked by #wrapper overflow:hidden)
        const inner = preview.querySelector('.gf-directory-preview__inner');
        if (inner) {
            const TOP_OFFSET = 32;
            let rafPending = false;
            let trackingActive = false;

            function updatePreviewPosition() {
                rafPending = false;
                if (!trackingActive) return;
                const wrapRect = outerWrap.getBoundingClientRect();
                const innerH = inner.offsetHeight;
                const wrapH = outerWrap.offsetHeight;

                if (wrapRect.top < TOP_OFFSET) {
                    let shift = TOP_OFFSET - wrapRect.top;
                    const maxShift = wrapH - innerH - TOP_OFFSET;
                    shift = Math.min(Math.max(shift, 0), Math.max(maxShift, 0));
                    inner.style.transform = `translateY(${shift}px)`;
                } else {
                    inner.style.transform = '';
                }
            }

            function onScrollThrottled() {
                if (!rafPending) {
                    rafPending = true;
                    requestAnimationFrame(updatePreviewPosition);
                }
            }

            function enableTracking() {
                trackingActive = true;
                window.addEventListener('scroll', onScrollThrottled, { passive: true });
                updatePreviewPosition();
            }

            function disableTracking() {
                trackingActive = false;
                window.removeEventListener('scroll', onScrollThrottled);
                inner.style.transform = '';
            }

            function onMqChange(e) {
                e.matches ? enableTracking() : disableTracking();
                const link = document.getElementById('gf-preview-scroll-link');
                if (link) link.style.display = e.matches ? 'none' : '';
            }

            // Modern API with fallback for older Safari
            if (mq.addEventListener) {
                mq.addEventListener('change', onMqChange);
            } else {
                mq.addListener(onMqChange);
            }

            // Initialize based on current viewport
            mq.matches ? enableTracking() : disableTracking();
        }
    }

    // Hook into GF's post-render action (fires on init and AJAX page turns)
    if (typeof gform !== 'undefined' && gform.addAction) {
        gform.addAction('gform_post_render', initDirectoryPreview);
    }

    // Fallback for synchronous render
    document.addEventListener('DOMContentLoaded', function () {
        initDirectoryPreview(FORM_ID);
    });
}());

// Write confirmation message to live region on form confirmation from all Gravity Forms forms
const handleGformConfirmation = (formId) => {
    if (!formId) return;
    const confWrap = document.getElementById(`gform_confirmation_wrapper_${formId}`);
    let live = document.getElementById(`gform_status_${formId}`);

    if (!live) {
        live = document.createElement('div');
        live.id = `gform_status_${formId}`;
        live.className = 'sr-only';
        live.setAttribute('role', 'status');
        live.setAttribute('aria-live', 'polite');
        live.setAttribute('aria-atomic', 'true');

        if (confWrap && confWrap.parentNode) {
            confWrap.parentNode.insertBefore(live, confWrap);
        }
    }

    if (!live) return;

    const text = confWrap ? confWrap.textContent.trim() : 'Form submitted successfully.';
    live.textContent = '';
    setTimeout(() => {
        live.textContent = text;
    }, 50);

    if (confWrap) {
        confWrap.setAttribute('tabindex', '-1');
        confWrap.focus();
    }
};

// Gravity Forms triggers this via jQuery on document
if (window.jQuery) {
    window.jQuery(document).on('gform_confirmation_loaded', function (event, formId) {
        handleGformConfirmation(formId);
    });
}

// Fallback if a native CustomEvent is dispatched
document.addEventListener('gform_confirmation_loaded', function (event) {
    const formId = event?.detail?.[0];
    handleGformConfirmation(formId);
});

// Inject clear buttons into GF fields marked with .btn_clear_field
function initClearableFields(root) {
    (root || document).querySelectorAll('.btn_clear_field').forEach(field => {
        const container = field.querySelector('.ginput_container');
        const input = container && container.querySelector('input[type="text"], input[type="email"], input[type="tel"], input[type="url"]');
        if (!input || field.querySelector('.gfield-clear-btn')) return;

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'gfield-clear-btn';
        btn.setAttribute('aria-label', 'Clear field');
        btn.setAttribute('title', 'Clear field');
        btn.hidden = !input.value;
        btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 16 16" aria-hidden="true" focusable="false" style="display:block;flex-shrink:0"><circle cx="8" cy="8" r="7.5" fill="currentColor"/><line x1="5" y1="5" x2="11" y2="11" stroke="#fff" stroke-width="1.75" stroke-linecap="round"/><line x1="11" y1="5" x2="5" y2="11" stroke="#fff" stroke-width="1.75" stroke-linecap="round"/></svg>';

        // position:relative and padding-right are in SCSS;
        // top is set dynamically below since it must be calculated at runtime.

        container.appendChild(btn);

        // Align to the vertical centre of the input (container is taller due to char counter)
        const alignBtn = () => {
            btn.style.top = (input.offsetTop + Math.round(input.offsetHeight / 2)) + 'px';
        };
        alignBtn();
        window.addEventListener('resize', alignBtn, { passive: true });

        input.addEventListener('input', () => { btn.hidden = !input.value; });

        btn.addEventListener('click', () => {
            input.value = '';
            btn.hidden = true;
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.focus();
        });
    });
}

// Run on DOM ready and again after GF re-renders (AJAX page turns)
document.addEventListener('DOMContentLoaded', () => initClearableFields());
if (typeof gform !== 'undefined' && gform.addAction) {
    gform.addAction('gform_post_render', () => initClearableFields());
}
